export default __webpack_public_path__ + "static/media/DocWorkflow.a2c272d3.png";